export default "/images/Kinopoisk.svg?7b7794a1cf7fb53a512bc7d69836b743";